// @ts-nocheck
import { Axios, Network } from "../../.."
import api from "../../../../../api/axios"
import store from "../../../../store"
import { PLAN_TYPE, STATUS_IDS } from "../../../constants"
import { formatDate, getCurrency } from "../../../formating"
import { Person } from "../profile"

export class ExpenseAllocationAttributes {
  constructor(attributes = {}) {
    Object.assign(this, attributes)
  }
}

export class ExpenseAttributes {
  constructor(attributes = {}) {
    Object.assign(this, attributes)
  }
}

class Expense extends ExpenseAttributes {
  static async getDailyActivity({ params: { employer, storeUser, paramsString } }) {
    if (employer?.id) paramsString += `&employerId=${employer?.id}`
    if (storeUser?.id) paramsString += `&userId=${storeUser?.id}`
    const { data } = await Network.AxiosWrapperV2.get({
      url: `dailyActivity/expense?${paramsString}`
    })
    const expenses = new Map()
    data.data.forEach((e) => {
      const { userId } = e
      const user = data.included.users[userId]
      const employer = user.employer

      expenses.set(
        e.id,
        new Expense({
          ...e,
          user: new Network.API.Profile.User({ ...user })
        })
      )
    })
    return expenses
  }

  static async getAll({ params: { processed } }) {
    let url = "expense/v2?includeProvider=true&includePatient=true&includeUnallocated=true"
    if (processed) url += "&includeProcessed=true"

    const response = await api.get(url)

    let expenses = response?.data?.data.map((expense) => new Expense(expense))
    expenses = expenses.sort((expenseA, expenseB) => expenseB.submittedTs - expenseA.submittedTs)

    expenses = expenses.reduce((expenses, expense) => {
      expense.premium = expense?.premium ? "Yes" : "No"
      expenses.set(expense?.id, expense)
      return expenses
    }, new Map())

    return expenses
  }

  static async getOne({ params }) {
    try {
      const [{ data: expenseData }] = await Promise.all([
        Network.AxiosWrapperV2.get({
          url: `expense/v2/${params.expenseId}?includePatient=true&includeProvider=true`
        })
      ])

      return new Expense({
        ...expenseData,
        patient: new Person(expenseData.patient)
      })
    } catch (err) {
      console.error(err)
    }
  }

  static async createOne({ data }) {
    try {
      const { data: expenseData } = await Network.AxiosWrapperV2.post({
        url: `expense/v2`,
        data
      })
      return new Expense(expenseData)
    } catch (err) {
      console.error(err)
    }
  }

  get dateOfServiceTs() {
    return formatDate({
      data: this?.serviceDate,
      actions: ["ts"],
      options: ["append-timezone"],
      defaultReturn: ""
    })
  }

  get unallocatedAmount() {
    return this?.amount - this?.allocatedAmount
  }

  get hraStatus() {
    const plan = this?.plan
    if (plan?.includes("HRA") || plan?.includes("FSA")) return this?.statusV2.short
    return ""
  }

  get patientName() {
    return this?.patient?.id ? `${this?.patient?.firstName} ${this?.patient?.lastName}` : ""
  }

  get providerName() {
    return this?.provider?.name || ""
  }

  get plan() {
    return this?.allocations?.[0]?.plan?.type
  }

  get realStatus() {
    return this?.statusV2?.long || this?.statusV2?.short
  }

  async update({ data }) {
    try {
      if (this?.links?.update) {
        const { data: expenseData } = await Network.AxiosWrapperV2.send({
          ...this?.links.update,
          data
        })
        return new Expense(expenseData)
      }
    } catch (err) {
      console.error(err)
      return null
    }
  }

  async delete() {
    try {
      if (this?.links?.delete) {
        await Network.AxiosWrapperV2.send(this?.links.delete)

        store.setNotification("notification", true, {
          msg: `Successfully deleted expense`
        })

        return true
      }
    } catch (error) {
      console.error(error)
    }
    return false
  }

  updateExpenseMedia = async ({ params, payload }) => {
    try {
      const mediaToAddRequests = payload.mediaToAdd?.map((m) => {
        return Network.AxiosWrapperV2.upload(
          `expense/${params.expenseId}/media`,
          m.file
        )
      })
      const mediaToDeleteRequests = payload.mediaToDelete?.map((m) => {
        return Network.AxiosWrapperV2.delete({
          url: `expense/${params.expenseId}/media/${m.id}`
        })
      })
      await Promise.all([...(mediaToAddRequests || []), ...(mediaToDeleteRequests || [])])
    } catch (err) {
      console.error(err)
    }
  }

  async allocate({ payload, params }) {
    const { amount } = payload
    const { expense, plan } = params

    try {
      if (this?.allocations?.length > 0) {
        const allocation = this?.allocations[0]
        await Network.AxiosWrapperV2.send({ ...allocation.links.delete })
      }

      await Network.AxiosWrapperV2.post({
        url: `expense/v2/${expense.id}/plan/${plan.id}/allocation`,
        data: payload
      })

      const formattedExpenseAmount = getCurrency({
        actions: ["divide"],
        amount: expense.amount
      })

      const formattedProcessedAmount = getCurrency({
        actions: ["divide"],
        amount
      })

      let message = `${formattedExpenseAmount} reimbursement submitted for ${plan.type}`

      store.setNotification("notification", true, { msg: message })
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export default Expense
